module.exports = __webpack_public_path__ + "fonts/naver-example-mobile.png!static";